<section class="content-layout" [brightsideWebFb]="{ event_name: 'contest_intro' }">
  <bw-action-article-legacy>
    <ui-nav-exit-back back-action-top [trackingDetail]="{ event_name: 'contest_intro' }">
    </ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <typography-legacy text-large-regular color="var(--secondary-text)" class="mb-sm">
            {{ 'CONTEST_INTRO_TITLE' | translate }}
          </typography-legacy>
          <p title-medium class="mb-sm">{{ 'CONTEST_INTRO_DESC' | translate }}</p>
          <div class="contest-intro__container mt-md">
            <div class="contest-intro__item">
              <bw-icon-legacy iconName="money_bag" color="var(--brand)" [size]="50" backgroundColor="var(--bg-blue)"></bw-icon-legacy>
              <div>
                <typography-legacy text-small class="contest-intro__item-detail-title">
                  {{ 'CONTEST_INTRO_ITEM1_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-intro__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_INTRO_ITEM1_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>

            <div class="contest-intro__item">
              <bw-icon-legacy iconName="plant_pot" color="var(--brand)" [size]="50" backgroundColor="var(--bg-blue)"></bw-icon-legacy>
              <div>
                <typography-legacy text-small class="contest-intro__item-detail-title">
                  {{ 'CONTEST_INTRO_ITEM2_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-intro__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_INTRO_ITEM2_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>

            <div class="contest-intro__item">
              <bw-icon-legacy iconName="pen" color="var(--brand)" [size]="50" backgroundColor="var(--bg-blue)"></bw-icon-legacy>
              <div>
                <typography-legacy text-small class="contest-intro__item-detail-title">
                  {{ 'CONTEST_INTRO_ITEM3_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-intro__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_INTRO_ITEM3_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button bw-button-legacy type="submit" [brightsideWebFb]="{ event_name: 'contest_intro' }" (click)="contestIntroClick()">
        {{ introCtaCopy | translate }}
      </button>
      <button bw-link-button-legacy [secondaryCta]="true" [brightsideWebFb]="{ event_name: 'contest_intro' }" (click)="showRules()">
        <span [innerHTML]="'CONTEST_INTRO_RULES' | translate"></span>
      </button>
    </div>
  </bw-action-article-legacy>
</section>
